import React, { useState, useLayoutEffect, useRef } from 'react';
import "./PeriodicElementSimple.css";

const PeriodicElementSimple = ({ size, color, number, element }) => {
    const wrapperRef = useRef(null);
    const [ratios, setRatios] = useState({ font: 1, position: 1 });

    useLayoutEffect(() => {
        const updateDimensions = () => {
            if (wrapperRef.current) {
                const width = wrapperRef.current.clientWidth;
                // Ton ratio de référence basé sur 198px
                const currentFontRatio = 198 / width;
                const currentPositionRatio = 1 - (Math.abs(currentFontRatio - 1) / 10);

                setRatios({
                    font: currentFontRatio,
                    position: currentPositionRatio
                });
            }
        };

        // Calcul immédiat au montage
        updateDimensions();

        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);

    // Styles extraits pour la clarté
    const boxStyle = {
        width: `${size}px`,
        height: `${size}px`
    };

    return (
        <span className="PeriodicElementSimple" style={boxStyle}>
            <div
                className="PeriodicElementSimple-Wrapper"
                style={{ ...boxStyle, borderColor: color }}
                ref={wrapperRef}
            >
                <p className="PeriodicElementSimple-Number"
                   style={{
                       fontSize: `${45 / ratios.font}px`,
                       top: `${1 / ratios.position}%`,
                       left: `${4 / ratios.position}%`,
                       color: color
                   }}>
                    {number}
                </p>
                <p className="PeriodicElementSimple-Element"
                   style={{
                       fontSize: `${102 / ratios.font}px`,
                       top: `${15 / ratios.position}%`,
                       color: color
                   }}>
                    {element}
                </p>
            </div>
        </span>
    );
};

export default PeriodicElementSimple;